export default __webpack_public_path__ + "static/media/steam.d7b8819f.svg";